/**
 * Local Storage Keys for any mgd variables using Local Storage
 */
export enum LocalStorage {
    SavedEmails = "mgdSavedEmails"
}
